import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sending"
export default class extends Controller {
  static targets = ["loadingScreen"]

  declare readonly loadingScreenTarget: HTMLElement
  declare readonly hasLoadingScreenTarget: boolean

  initialize() {
    // Turbo を読み込んだらローディングを消す
    document.addEventListener('turbo:load', () => {
      this.hideLoadingScreen()
    })
    // フォーム送信が完了したらローディングを消す（Turbo Stream での更新にも対応）
    document.addEventListener('turbo:submit-end', () => {
      this.hideLoadingScreen()
    })
  }

  connect() {
    // ブラウザバックを含むページ遷移の都度コールしてローディングをリセット
    if (this.hasLoadingScreenTarget) {
      this.hideLoadingScreen()
    }
  }

  // 確認ダイアログを表示してからフォーム送信を行う
  confirmAndSubmit(event: Event): void {
    event.preventDefault()

    const target = event.target as HTMLElement
    const confirmMessage = target.getAttribute('data-confirm-message')

    if (confirmMessage) {
      if (!confirm(confirmMessage)) {
        return
      }
    }

    // 確認が取れた場合、フォームバリデーションをチェック
    if (this.element instanceof HTMLFormElement) {
      const form = this.element as HTMLFormElement
      if (!form.checkValidity()) {
        // フォームのバリデーションを実行してエラーメッセージを表示
        form.reportValidity()
        return
      }

      // ローディング画面を表示
      if (this.hasLoadingScreenTarget) {
        this.loadingScreenTarget.style.setProperty("display", "block")
      }

      // フォームを送信
      form.submit()
    }
  }

  // HTMLのフォームバリデーションをチェックし、エラーがある場合は処理を停止する
  // 万が一、HTMLバリデーションエラーでローディングが出たままになってしまうのを防止する
  submit(event: Event): void {
    // 要素がフォームの場合のみバリデーションチェックを実行
    if (this.element instanceof HTMLFormElement) {
      const form = this.element as HTMLFormElement
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()

        // フォームのバリデーションを実行してエラーメッセージを表示
        form.reportValidity()
        return
      }
    }
    // バリデーションが通った場合、またはフォーム以外の要素の場合、ローディング画面を表示して送信処理を続行
    if (this.hasLoadingScreenTarget) {
      this.loadingScreenTarget.style.setProperty("display", "block")
    }
  }

  hideLoadingScreen() {
    if (this.hasLoadingScreenTarget) {
      this.loadingScreenTarget.style.setProperty("display", "none")
    }
  }

  disconnect() {
    if (this.hasLoadingScreenTarget) {
      this.hideLoadingScreen()
    }
  }
}
